var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreheat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1725980910269,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 162613,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.16 872.32V151.68c0-41.6 33.92-76.16 75.52-76.16h445.76v94.72c0 83.84 68.48 151.68 151.68 151.68h113.92v154.688h75.52V301.44c0-41.6-14.72-80-43.52-108.16L745.28 43.52c-30.08-28.8-68.48-43.52-108.16-43.52H151.68C68.48 0 0 67.84 0 151.68v720.64C0 955.52 68.48 1024 151.68 1024H512v-76.16H151.68c-41.6 0-75.52-33.92-75.52-75.52z m597.44-787.2c5.12 3.84 10.88 7.68 16.64 13.44l147.84 147.84h-88.96c-41.6 0-75.52-33.92-75.52-76.16V85.12z",
    fill: "#1b283a",
    "p-id": 162614
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M855.936 766.464h-30.848c-4.48 0-8.064-3.136-8.064-7.616v-113.984a8 8 0 0 0-8.064-8.064h-50.048a8 8 0 0 0-8.064 8.064v113.984c0 4.48-3.584 7.616-8.064 7.616h-30.4c-5.824 0-9.856 6.272-7.616 11.2l16.576 34.432 55.424 114.432a7.808 7.808 0 0 0 14.336 0l72-148.864c2.24-4.928-1.344-11.2-7.168-11.2z",
    fill: "#1b283a",
    "p-id": 162615
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M784 544c-17.984 0-35.968 1.792-52.8 6.016a251.52 251.52 0 0 0-67.2 25.792A240.448 240.448 0 0 0 544 784 239.936 239.936 0 0 0 784 1024 239.936 239.936 0 0 0 1024 784a239.936 239.936 0 0 0-240-240z m0 423.616a183.616 183.616 0 0 1-183.616-183.616c0-55.168 24.576-105.024 63.616-138.624 19.2-16.768 41.984-30.016 67.2-37.184a183.616 183.616 0 1 1 52.8 359.424z",
    fill: "#1b283a",
    "p-id": 162616
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreheat);
export default __webpack_public_path__ + "static/media/preheat.384602686bc88a3710eafc4610a7c6d9.svg";
export { ForwardRef as ReactComponent };